import { createStore, compose, applyMiddleware, AnyAction } from 'redux'
// import thunkMiddleware, { ThunkMiddleware } from "redux-thunk";
import { createLogger } from 'redux-logger'
import { rootReducer } from '../Reducers/index'

// Create logger middleware
const loggerMiddleware: any = createLogger()

// Use Redux DevTools extension if available, otherwise fallback to Redux's compose
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// Create the store with rootReducer and apply middleware (thunk and logger)
const Store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      // thunkMiddleware as ThunkMiddleware<any, AnyAction>,  // Explicitly typing thunkMiddleware
      loggerMiddleware, // Logger middleware now correctly typed
    ),
  ),
)

export default Store
